import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; // @ts-check

import React from 'react';
import Form from '../../../../../../form';
import { useDashboardState } from '../../context/dashboardContext';
import Icon from '../../../../../Icon';
import { Grid, Menu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { selectDimension } from '../../context/selectors/dimensionSelector';
var useStyles = makeStyles({
  /**
   * These properties are copied from the default
   * implementation to allow text trimming overflow
   */
  selectItem: {
    overflow: 'hidden',
    maxWidth: 'calc(100% - 8px)',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    boxSizing: 'border-box',
    marginLeft: function marginLeft(props) {
      return props.variant === 'standard' ? 0 : 2;
    },
    marginRight: 2
  },
  valueContainer: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: function padding(props) {
      return props.variant === 'standard' ? '2px 0px' : '2px 8px';
    },
    position: 'relative',
    overflow: 'hidden',
    boxSizing: 'border-box',
    minHeight: 38,
    cursor: 'pointer'
  }
}, {
  name: 'ECDimensionSelect'
});
var functionsOptions = [{
  value: null,
  label: 'NONE'
}, {
  value: 'sum',
  label: 'SUM',
  isNumeric: true
}, {
  value: 'count',
  label: 'COUNT'
}, {
  value: 'distinct-count',
  label: 'DISTINCT COUNT'
}, {
  value: 'min',
  label: 'MIN',
  isNumeric: true
}, {
  value: 'max',
  label: 'MAX',
  isNumeric: true
}, {
  value: 'avg',
  label: 'AVG',
  isNumeric: true
}, {
  value: 'first',
  label: 'FIRST'
}, {
  value: 'last',
  label: 'LAST'
}, {
  value: 'only',
  label: 'ONLY'
}];

var parseValue = function parseValue(value) {
  if (!value) return {
    dimensionName: null,
    func: null
  };
  var axisStartIndex = value.indexOf('(');
  var axisEndIndex = value.indexOf(')');
  if (axisStartIndex === -1 || axisEndIndex === -1) return {
    dimensionName: value,
    func: null
  };
  return {
    dimensionName: value.substring(axisStartIndex + 1, axisEndIndex),
    func: value.substring(0, axisStartIndex)
  };
};

var isNumericDimension = function isNumericDimension(dimension) {
  if (!dimension) return false;

  switch (dimension.type) {
    case 'short':
    case 'double':
    case 'float':
    case 'int':
    case 'int64':
      return true;

    default:
      return false;
  }
};

var DimensionSelect = function DimensionSelect(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'standard' : _ref$variant,
      _ref$hasFunction = _ref.hasFunction,
      hasFunction = _ref$hasFunction === void 0 ? false : _ref$hasFunction,
      _ref$forceFunction = _ref.forceFunction,
      forceFunction = _ref$forceFunction === void 0 ? false : _ref$forceFunction;
  var dashboardState = useDashboardState();

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      functionAnchorEl = _React$useState2[0],
      setFunctionAnchorEl = _React$useState2[1];

  var classes = useStyles({
    variant: variant
  });

  var getIconType = function getIconType(dimension) {
    if (isNumericDimension(dimension)) return 'number-format';
    if (dimension.type === 'date') return 'date';
    return 'alphabetical';
  };

  var dataOptions = dashboardState.data.tables.map(function (table) {
    return {
      label: table.name,
      options: table.dimensions.map(function (dimension) {
        return {
          icon: getIconType(dimension),
          label: dimension.name,
          value: dimension.name
        };
      })
    };
  });

  var handleFunctionClick = function handleFunctionClick(event) {
    setFunctionAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setFunctionAnchorEl(null);
  };

  var _parseValue = parseValue(value),
      func = _parseValue.func,
      dimensionName = _parseValue.dimensionName;

  var handleDimensionChange = function handleDimensionChange(newDimension) {
    var currentFunction = null;
    if (forceFunction) currentFunction = getFunctionForDimension(newDimension);
    onChange(getValue(currentFunction, newDimension));
  };

  var getFunctionForDimension = function getFunctionForDimension(dimensionName) {
    var dimension = selectDimension(dashboardState, dimensionName);
    if (!dimension) return null;
    return isNumericDimension(dimension) ? 'sum' : 'count';
  };

  var getValue = function getValue(currentFunc, currentDimension) {
    if (!currentDimension) return '';
    return currentFunc !== null ? "".concat(currentFunc, "(").concat(currentDimension, ")") : currentDimension;
  };

  var handleFunctionChange = function handleFunctionChange(func) {
    onChange(getValue(func, dimensionName));
    handleClose();
  };

  var currentDimensionIsNumeric = dimensionName && isNumericDimension(selectDimension(dashboardState, dimensionName));

  var shouldDisable = function shouldDisable(option) {
    if (option.value === null) return forceFunction;
    return option.isNumeric && !currentDimensionIsNumeric;
  };

  return React.createElement(Grid, {
    item: true,
    container: true,
    alignItems: "center",
    wrap: "nowrap"
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Form.Input.MultiSelect, {
    required: true,
    value: dimensionName,
    onChange: handleDimensionChange,
    variant: variant,
    options: dataOptions,
    components: {
      SingleValue: function SingleValue() {
        return React.createElement("div", {
          className: classes.selectItem
        }, getValue(func, dimensionName));
      },
      ValueContainer: function ValueContainer(props) {
        return React.createElement("div", {
          className: classes.valueContainer
        }, props.children);
      }
    }
  })), hasFunction && React.createElement(React.Fragment, null, React.createElement(Grid, {
    item: true
  }, React.createElement(Icon, {
    color: "action",
    type: "sigma",
    buttonSize: "medium",
    label: "Expression",
    disabled: dimensionName === null,
    onClick: handleFunctionClick
  }), React.createElement(Menu, {
    anchorEl: functionAnchorEl,
    keepMounted: true,
    open: Boolean(functionAnchorEl),
    onClose: handleClose
  }, functionsOptions.map(function (option) {
    return React.createElement(MenuItem, {
      key: option.value,
      onClick: function onClick() {
        return handleFunctionChange(option.value);
      },
      disabled: shouldDisable(option)
    }, option.label);
  })))));
};

export default DimensionSelect;